import { getCookie, getSession } from './index';

export const isMVA = () => window.navigator.userAgent.indexOf('MY_VZW_APP') > -1;

export const isIphone = () => window.navigator?.platform?.toLowerCase().indexOf('iphone') > -1;

export const iOSAPP = () => window.navigator.userAgent.indexOf('VZW-MFA-IOS') > -1;

export const androidAPP = () => window.navigator.userAgent.indexOf('VZW-MFA-ANDROID') > -1;

export const isMVAProspect = () => {
  const loggedInCookie = getCookie('loggedIn') === true || getCookie('loggedIn') === 'true';
  const mfClientData = getSession('mfAppProps');
  const parsedData = mfClientData ? JSON.parse(mfClientData) : {};
  return !loggedInCookie && parsedData.lob === 'vzp' && isMVA();
};

export const Tablet = () => {
  let isTablet = null;
  let userAgentString = window.navigator && window.navigator.userAgent;
  // const silkModeExp = 'Mobile Safari';
  // To identify Tablet devices
  if (userAgentString) {
    userAgentString = userAgentString.toLowerCase();
    if (
      (userAgentString.includes('windows') && userAgentString.includes('touch')) ||
      userAgentString.includes('tablet') ||
      userAgentString.includes('ipad')
    ) {
      isTablet = true;
    }
    // if (!userAgentString.includes(silkModeExp)) {
    //   isTablet = true;
    // }
  }

  return isTablet;
};

export const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;

export const isIE = navigator.userAgent.indexOf('MSIE') > -1;

export const isMobile = () => {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i) ||
    navigator.userAgent.match(/MY_VZW_APP/i) ||
    navigator.userAgent.includes('MY_VZW_APP')
  ) {
    return true;
  }
  return false;
};

export const viewport = () => {
  if (isMVA()) {
    return 'mfapp';
  }
  if (isMobile()) {
    return 'mobile';
  }
  if (Tablet()) {
    return 'tablet';
  }
  return 'desktop';
};

export const validateUrl = (str) => {
  if (str) {
    return str.replace(/</g, '<').replace(/>/g, '>');
  }
  return '';
};

export const getOS = () => {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'Mac'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = '';

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};
